import { render, staticRenderFns } from "./unit-type.vue?vue&type=template&id=663db044&scoped=true"
import script from "./unit-type.vue?vue&type=script&lang=js"
export * from "./unit-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663db044",
  null
  
)

export default component.exports